import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ArrayField from './Array';
import ObjectField from './Object';
import StringField from './String';
import NullField from './Null';
import UnsupportedField from './Unsupported';
import { Dthc } from '../../../../Modules';
import styles from '../../Form.scss';
import SchemaFieldEditDesktop from './SchemaFieldEditDesktop';
import SchemaFieldEditMobile from './SchemaFieldEditMobile';
import changeQuestionType from '../changeQuestionType';

const COMPONENT_TYPES = {
  array: ArrayField,
  boolean: UnsupportedField,
  integer: UnsupportedField,
  number: UnsupportedField,
  object: ObjectField,
  string: StringField,
  null: NullField
};

export default class SchemaField extends React.Component {
  static propTypes = {
    deleteResponse: PropTypes.func,
    formData: PropTypes.any,
    deleteQuestion: PropTypes.func.isRequired,
    objectKey: PropTypes.string,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    updateForm: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      schema: _.cloneDeep(this.props.schema),
      uiSchema: _.cloneDeep(this.props.uiSchema),
      formData: _.cloneDeep(this.props.formData),
      deleting: false
    };
    this.getQuestionType = this.getQuestionType.bind(this);
    this.onQuestionTypeChange = this.onQuestionTypeChange.bind(this);
    this.deleteQuestion = this.deleteQuestion.bind(this);
    this.reset = this.reset.bind(this);
    this.onChange = this.onChange.bind(this);
    this.commitUpdate = this.commitUpdate.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.schema.type === 'object') {
      this.setState({
        schema: _.cloneDeep(nextProps.schema),
        uiSchema: _.cloneDeep(nextProps.uiSchema),
        formData: _.cloneDeep(nextProps.formData)
      });
    }
  }

  onChange(form, callback) {
    this.setState(form, callback);
  }

  onQuestionTypeChange(e) {
    const {
      schema,
      uiSchema,
      formData,
      updateForm,
      deleteResponse
    } = this.props;
    changeQuestionType({
      to: e.target.value,
      from: this.getQuestionType(),
      onChange: this.onChange,
      schema,
      uiSchema,
      formData,
      localSchema: this.state.schema,
      localUiSchema: this.state.uiSchema,
      localFormData: this.state.formData,
      updateForm,
      deleteResponse
    });
  }

  getQuestionType() {
    switch (this.state.schema.type) {
      case 'string':
        switch (this.state.uiSchema && this.state.uiSchema['ui:widget']) {
          case 'radio':
            return 'radio';
          case 'select':
            return 'select';
          case 'textArea':
            return 'textArea';
          default:
            return 'text';
        }
      case 'array':
        switch (this.state.uiSchema && this.state.uiSchema['ui:widget']) {
          case 'table':
            return 'table';
          case 'checkboxes':
            return 'checkboxes';
          default:
            return 'textList';
        }
      case 'object':
        switch (this.state.uiSchema && this.state.uiSchema['ui:widget']) {
          case 'table':
            return 'table';
          default:
            return 'table';
        }
      default:
        return 'text';
    }
  }

  deleteQuestion(key) {
    this.setState({ deleting: true }, () => this.props.deleteQuestion(key));
  }

  commitUpdate(callback) {
    // Check if deleting due to DTHC onclickoutside
    if (!this.state.deleting) {
      new Promise(resolve => {
        this.props.onChange(
          {
            schema: this.state.schema,
            uiSchema: this.state.uiSchema,
            formData: this.state.formData
          },
          resolve
        );
      })
        .then(
          () =>
            new Promise(resolve => {
              // Remove bad form data
              if (
                // Radio and Select widgets
                this.state.uiSchema && (this.state.uiSchema['ui:widget'] === 'select' ||
                  this.state.uiSchema['ui:widget'] === 'radio') &&
                !this.state.schema.enum.includes(this.state.formData)
              ) {
                this.props.deleteResponse(resolve);
              } else if (
                // Checkboxes
                this.state.uiSchema && this.state.uiSchema['ui:widget'] === 'checkboxes'
              ) {
                const newFormData =
                  this.state.formData &&
                  this.state.formData.filter(item =>
                    this.state.schema.items.enum.includes(item)
                  );
                this.props.onChange({
                  schema: this.state.schema,
                  uiSchema: this.state.uiSchema,
                  formData: newFormData
                }, resolve);
              } else {
                resolve();
              }
            })
        )
        .then(() => {
          this.props.updateForm(callback);
        });
    }
  }

  reset(e, callback) {
    this.setState(
      {
        schema: _.cloneDeep(this.props.schema),
        uiSchema: _.cloneDeep(this.props.uiSchema),
        formData: _.cloneDeep(this.props.formData)
      },
      callback
    );
  }

  render() {
    const { onChange, updateForm, objectKey, formData } = this.props;
    const { title, type } = this.state.schema;
    const description = this.state.uiSchema && this.state.uiSchema['ui:description'];
    const FieldComponent = COMPONENT_TYPES[type];
    return (
      <div className={styles.fieldSpacing}>
        {type === 'object' &&
          <div>
            <h2>
              {title}
            </h2>
            <FieldComponent
              schema={this.state.schema}
              uiSchema={this.state.uiSchema}
              onChange={onChange}
              updateForm={updateForm}
              deleteQuestion={this.deleteQuestion}
              formData={formData}
              updateForm={updateForm}
            />
          </div>}
        {type !== 'object' &&
          <Dthc
            desktop={SchemaFieldEditDesktop}
            mobile={SchemaFieldEditMobile}
            FieldComponent={FieldComponent}
            schema={this.state.schema}
            uiSchema={this.state.uiSchema}
            getQuestionType={this.getQuestionType}
            onChange={this.onChange}
            onQuestionTypeChange={this.onQuestionTypeChange}
            commitUpdate={this.commitUpdate}
            deleteQuestion={this.deleteQuestion}
            handleClickOutside
            editing
            objectKey={objectKey}
            formData={this.state.formData}
            reset={this.reset}
          >
            <div style={{ padding: '1em' }}>
              {type !== 'null' &&
                <div>
                  <h3 className={[styles.fieldTitle, title ? '' : styles.questionPlaceholder].join(' ')}>
                    {title || 'Question'}
                  </h3>
                  <div className={styles.fieldDescription}>{description}</div>
                </div>}
              <FieldComponent
                formData={this.state.formData}
                schema={this.state.schema}
                uiSchema={this.state.uiSchema}
                onChange={onChange}
              />
            </div>
          </Dthc>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/Fields/SchemaField.js